import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleActionService {
  private apiService = inject(ApiService);

  storeRoleAssigment(roleID: number, actionID: number) {
    return this.apiService.store(
      `roleAction?roleid=${roleID}&actionid=${actionID}&createdBy=test`,
      undefined
    );
  }

  deleteRoleAsssignment(id: number) {
    return this.apiService.delete(`roleAction`, id);
  }

  getRoleAssigned(id: number): Observable<any> {
    return this.apiService.getAll(
      `roleAction/getActionsAssignedRole?rolid=${id}`
    );
  }

  getRoleNotAssigned(id: number): Observable<any> {
    return this.apiService.getAll(
      `roleAction/getActionsNotAssignedRole?rolid=${id}`
    );
  }

  getRoleAssignment(id: number): Observable<any> {
    return this.apiService.getById('', id);
  }
}
